import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import flexible from '../../../utils/flexible.js';
import audioItem from '../../../components/audioItem';
import guideBottom from '@/components/guideBottom.vue';
export default {
  name: 'audios',
  data() {
    return {
      bannersList: [],
      detail: {},
      //展览详情
      formData: {},
      exhibCode: '',
      isFolded: true,
      audioList: [],
      exhibName: '',
      language: '',
      recordList: []
    };
  },
  components: {
    audioItem,
    guideBottom
  },
  methods: {
    getType(type) {
      return type == '常设展览' ? 'permanent' : 'temporary';
    },
    getIdDetail() {
      let searchStr = {
        filters: [[{
          alias: '10',
          compt: "autonumber",
          express: '===',
          id: 10,
          range: null,
          val: this.exhibCode
        }]],
        model: 0
      };
      let data = {
        page: 1,
        limit: 100,
        deptId: this.formData.fid,
        formId: this.formData.exhibition_formId,
        searchStr: encodeURI(JSON.stringify(searchStr))
      };
      this.$api.singleadvanceSearch(data).then(res => {
        let list = this.setDatas(res.dataList, 'banner');
        this.detail = list[0];
        if (!this.detail.exhibName) return;
        document.title = this.detail.exhibName;
        this.exhibName = this.detail.exhibName;
        this.getAudioList();
      });
    },
    getAudioList(page) {
      let searchStr;
      if (!this.$route.query.isPersonalCenter) {
        searchStr = this.$route.query.searchKey ? {
          filters: [[{
            alias: 'explainObj',
            compt: "editinput",
            express: 'like',
            range: null,
            val: this.$route.query.searchKey
          }]],
          model: 0
        } : {
          filters: [[{
            alias: 'exhibitionName',
            compt: "editinput",
            express: '===',
            id: 1,
            range: null,
            val: this.exhibName
          }]],
          model: 0
        };
      } else {
        searchStr = '';
      }
      let data = {
        page: page || 1,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId,
        searchStr: encodeURI(JSON.stringify(searchStr)),
        orderBy: 'manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(data).then(res => {
        let list = this.setDatas(res.dataList, 'list');
        list = this.language ? list.filter(item => {
          return item.en_antiqueName;
        }) : list;
        if (page) {
          //我的浏览记录需要分页
          this.audioList = this.audioList.concat(list);
          if (page != res.totalPage) {
            return this.getAudioList(page + 1);
          } else {
            let guideRecord = window.localStorage.getItem('guideRecord') ? JSON.parse(window.localStorage.getItem('guideRecord')) : [];
            this.recordList = this.audioList.filter(item => {
              return guideRecord.indexOf(item.code) > -1;
            });
          }
        } else {
          return this.audioList = list;
        }
      });
    },
    toggleFold() {
      this.isFolded = !this.isFolded;
    },
    setDatas(data, type) {
      return data.map(item => {
        return type == 'list' ? {
          exhibitionName: this.getFormData(item, 'exhibitionName', 'val'),
          antiqueName: this.getFormData(item, 'explainObj', 'val'),
          littleImage: this.getFormData(item, 'image', 'fileUrl'),
          exhibitionLocation: this.language ? this.detail.en_location : this.detail.exhibitionLocation,
          code: this.getFormData(item, 'autoCode', 'val'),
          audioPath: !this.language ? this.getFormData(item, 'audio', 'objectId') : this.getFormData(item, 'en_audio', 'objectId'),
          description: this.getFormData(item, 'introduction', 'val'),
          en_antiqueName: this.getFormData(item, 'en_explainObj', 'val'),
          en_description: this.getFormData(item, 'en_introduction', 'val')
        } : {
          exhibName: this.getFormData(item, 'name', 'val'),
          price: this.getFormData(item, 'expend', 'val'),
          exhibType: this.getFormData(item, 'type', 'val'),
          images: this.getFormData(item, 'image', 'fileUrl'),
          exhibitionLocation: this.getFormData(item, 'address', 'val'),
          exhibBegin: this.getFormData(item, 'startTime', 'val'),
          exhibEnd: this.getFormData(item, 'endTime', 'val'),
          description: this.getFormData(item, 'description', 'val'),
          en_name: this.getFormData(item, 'en_name', 'val'),
          en_location: this.getFormData(item, 'en_location', 'val'),
          en_desc: this.getFormData(item, 'en_desc', 'val')
        };
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    }
  },
  created() {
    flexible();
    let query = this.$route.query;
    this.formData = {
      exhibition_formId: 171924,
      audio_formId: 171925,
      fid: query.fid
    };
    this.exhibCode = query.exhibCode;
    this.language = this.$route.query.language;
    // 首页搜索参数的情况
    if (this.$route.query.searchKey || this.$route.query.isPersonalCenter) return this.getAudioList(1);
    this.getIdDetail();
  },
  watch: {
    '$route'(to, from) {
      console.log(to, 'to');
      if (to.name == "audios") {
        location.reload();
      }
    }
  }
};